import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 分页查询担保机构
export const guaranteePage = (data: any) =>
  request.post('/admin/guarantee/page', data, jsonHeaderConfig)

// 新增担保机构
export const addGuarantee = (data: any) =>
  request.post('/admin/guarantee/add', data, jsonHeaderConfig)

// 删除担保机构
export const deleteGuarantee = (data: any) => request.post('/admin/guarantee/delete', data)

// 修改担保机构
export const updateGuarantee = (data: any) =>
  request.post('/admin/guarantee/update', data, jsonHeaderConfig)

// 获取担保机构应用列表
export const getGuaranteeApps = () =>
  request.get('/admin/application/guarantee/appList', null, jsonHeaderConfig)

// 可用授权数量
export const getGrantNumber = () =>
  request.get('/admin/guarantee/grantNumber', null, jsonHeaderConfig)

// 启用 禁用
export const enableGuarantee = (data: any) => request.post('/admin/tenant/enable', data)

// 启用 禁用
export const getGuaranteeDetails = (data: any) => request.get('/admin/guarantee/details', data)

// 禁用前判断
export const judgeGuarantee = (data: any) => request.post('/erp/retailIntoInfo/onRouteInto', data)
// 查询分公司
export const selectGroupFilialeId = (data: any) =>
  request.post('/erp/web/youka/proxy_config/selectGroupFilialeId', data)

export const selectPersonComponent = (data: any) =>
  request.post('/erp/web/youka/proxy_config/selectPersonComponent', data, jsonHeaderConfig)
